<template slot="header">

  <div class="ti-table ti_border"
       v-bind:class="{ ti_dashedborder: hasDashBorder, ti_space: !isHeader }"
       v-b-tooltip.hover
       v-b-tooltip.nofade="getTooltipText"
       v-show="getIsAvailable">

    <div class="ti-headerrow ti-cell"
         v-bind:class="{ ti_bg: isHeader, ti_bg_lite: !isHeader }">
      <div style="word-wrap: break-word;">
        <p v-bind:class="[ 'text-center', 'ml-0', { narrow_05: isNarrow, narrow_10: isVeryNarrow, localheading: isHeader }]">
          {{ getKpiName }}
        </p>
      </div>
    </div>

    <div class="ti-row">
      <div class="ti-cell">
        <performanceitem :invertArrow="invertArrow"
                         :overallByWave="overallByWave"
                         :kpi="kpi"
                         :monochrome="monochrome" />
      </div>
    </div>
  </div>

</template>


<script>
  import performanceitem from './PerformanceItem'

  export default {
    name: 'TableItem',
    components: {
      performanceitem
    },
    props:{
      overallByWave: { type: Object},
      kpi: { type: Object},
      hideNSC: { type: Boolean},
      nsckpi: { type: Object},
      isHeader: { type: Boolean},
      hasDashBorder: { type: Boolean},
      monochrome: { type: Object},
      noLetterSpacing: { type: Boolean},
      invertArrow: { type: Object}
    },
    methods:{
      isLongText: function (text) {
        if (text === null) {
          return false;
        }
        return text.length > 24
      }
    },
    computed: {
      getTooltipText: function() {
        if (!this.kpi || !this.kpi.KpiName)
          return ''
        return this.kpi.KpiName
      },
      isNarrow: function () {
        if (!this.kpi || !this.kpi.KpiName) { return false }
        return this.noLetterSpacing !== true && this.getKpiName.length > 22 && this.getKpiName.length <= 30
      },
      isVeryNarrow: function () {
        return this.noLetterSpacing !== true && this.getKpiName.length > 30
      },
      getKpiName: function() {
        if (this.kpi) {
          if (this.kpi.KpiNameShort) {
            return this.kpi.KpiNameShort;
          }
          if (this.kpi.KpiName) {
            return this.kpi.KpiName;
          }
        }
        return 'nicht verfügbar'
      },
      getIsAvailable: function() {
          if (!this.kpi || !this.kpi.KpiName) {
           return false
        }
        return true
      }
    }
  }

</script>

<style scoped>
  .localheading {
     font-size: 12pt;
     height: 48px;
     text-align: center;
     width: 100%;
  }

  p{
    word-wrap: break-word;
    font-size: 8pt;
    font-weight: bold;
    font-stretch: extra-condensed;
    margin-bottom:0px;
    margin-left: 3px;
  }
</style>